import { render, staticRenderFns } from "./ContactDuplicatesListItem.vue?vue&type=template&id=70b07df3"
import script from "./ContactDuplicatesListItem.vue?vue&type=script&lang=js"
export * from "./ContactDuplicatesListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports